import { DatePipe } from '@angular/common';
import { FieldSpec } from '@k2/common/k2-forms-state/types';

export function multidateFormatter(datePipe: DatePipe, field: FieldSpec): string {
  let values = field.value || [];
  return values.map(value => datePipe.transform(value, 'shortDate', '+0000')).join('\n');
}
